import { render, staticRenderFns } from "./IconTypeformThankyouScreen.vue?vue&type=template&id=1d2a55ce&"
import script from "./IconTypeformThankyouScreen.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformThankyouScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports